import { useResendVerifyMutation } from '@hook/auth/auth.hooks';
import { useStoreSelector } from '@hook/store/store.hooks';
import { useAuthorized } from '@hook/user/use-authorized.hook';

export const useUserVerified = () => {
  const { isAuthorized } = useAuthorized();
  const isVerified = useStoreSelector((state) => state.user.data.isVerified);
  const [onResend, { isSuccess, isLoading }] = useResendVerifyMutation();

  return {
    isAuthorized,
    isVerified,
    onResend: () => onResend(undefined),
    isSuccess,
    isLoading,
  };
};
